'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _setTimeout = require('common/utils/set-timeout');

var _setTimeout2 = _interopRequireDefault(_setTimeout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _ref = _jsx('b', {
  className: 'ico'
});

var _ref2 = _jsx('b', {
  className: 'ico'
});

var _ref3 = _jsx('b', {
  className: 'ico'
});

var _ref4 = _jsx('b', {
  className: 'ico'
});

var _ref5 = _jsx('b', {
  className: 'ico'
});

var TeamMember = _react2['default'].createClass({
  displayName: 'TeamMember',


  /**
   */

  propTypes: {
    "member": _react2['default'].PropTypes.object.isRequired
  },

  /**
   */

  getInitialState: function getInitialState() {
    return {};
  },

  /**
   */

  setMemberRole: function setMemberRole(code, event) {

    if (this.props.member.isLoggedInUser() && this.props.member.canModifyTeam() && !confirm("Are you sure you want to revoke your Admin privileges? You will no longer be able to modify your team.")) {
      return;
    }

    this.props.member.promote(code);
    event.preventDefault();
    event.stopPropagation();
  },

  /**
   */

  removeMember: function removeMember(event) {

    event.preventDefault();

    var removeText = "Are you sure you want to remove this user from your team? Note: this user's account will still exist. However, they will no longer be";
    removeText += this.props.member.pending ? " invited to join your team." : " part of your team.";
    if (_hfReactHelper2['default'].isHelloSign() && !this.props.member.pending) removeText += " IMPORTANT: Any templates this user created will be transferred to you and their signatures will be removed from them.";

    if (!confirm(removeText)) {
      return;
    }

    this.props.member.remove();
  },

  /**
   */

  toggleMenu: function toggleMenu(show, event) {
    clearTimeout(this._hideTimeout);

    // TODO: clean me - hack to prevent menu from hiding too quickly - this
    // needs to be placed within a menu component (CC)
    var self = this;
    if (show) {
      this.setState({ 'showMenu': show });
    } else {
      this._hideTimeout = (0, _setTimeout2['default'])(function () {
        self.setState({ 'showMenu': show });
      }, 100);
    }
  },

  /**
   */

  showTemplates: function showTemplates() {

    // TODO: reactify this component - here to support legacy stuff
    // for now
    var a = document.createElement("a");
    var guid = this.props.member.guid || this.props.member.uid;
    a.setAttribute("href", "/home/viewTemplatePermissionsForAccount?guid=" + guid);

    $(a).fancybox({
      "showCloseButton": false,
      "type": "iframe",
      "height": 375,
      "width": 500
    }).click();
  },

  /**
   */

  toggleCloseButton: function toggleCloseButton(show) {
    this.setState({
      'showClose': show
    });
  },

  /**
  * Returns true for Admins (owners) and Developers
  */
  shouldShowActionMenu: function shouldShowActionMenu() {
    return this.props.teamMembers && this.props.teamMembers.loggedInUserCanModifyTeam();
  },

  /**
  *
  */
  userIsAdmin: function userIsAdmin() {
    return this.props.teamMembers && this.props.teamMembers.loggedInUserIsAdmin();
  },

  getNumAdmins: function getNumAdmins() {
    var count = 0;
    var members = this.props.teamMembers;
    for (var i = 0; i < members.length; i++) {
      var member = members.at(i);
      if (members.at(i).isAdmin()) {
        count++;
      }
    }
    return count;
  },

  /**
   */

  render: function render() {

    var member = this.props.member;
    var loggedInUser = this.props.teamMembers.getLoggedInUser();
    var isSoleAdmin = typeof loggedInUser != 'undefined' && member.emailAddress === loggedInUser.emailAddress && this.getNumAdmins() < 2;

    var classNames = (0, _classnames2['default'])({
      'team_member': true,
      'show': this.state.showMenu
    });

    var sections = {};

    // User administration functions only available to Admins, not Devs
    if (this.userIsAdmin()) {
      if (!member.isAdmin()) {
        sections.adminMenuItem = _jsx('li', {
          className: 'menuLink make-admin'
        }, 'make-admin', _jsx('a', {
          href: '#',
          onClick: this.setMemberRole.bind(this, "a")
        }, void 0, _ref, 'Make Admin'));
      }

      if (!member.isDeveloper() && !isSoleAdmin) {
        sections.devMenuItem = _jsx('li', {
          className: 'menuLink make-developer'
        }, 'make-developer', _jsx('a', {
          href: '#',
          onClick: this.setMemberRole.bind(this, "d"),
          style: { 'fontSize': '10px' }
        }, void 0, _ref2, 'Make Developer'));
      }

      if (!member.isMember() && !isSoleAdmin) {
        sections.memberMenuItem = _jsx('li', {
          className: 'menuLink make-member'
        }, 'make-member', _jsx('a', {
          href: '#',
          onClick: this.setMemberRole.bind(this, "m"),
          style: { 'fontSize': '10px' }
        }, void 0, _ref3, 'Make Member'));
      }
    }

    if (member.pending) {

      var closClassNames = (0, _classnames2['default'])({
        'action_col': true,
        'show': this.state.showClose
      });

      // TODO - move to scss file when scss is organized (CC)
      sections.actionsColumn = _jsx('td', {
        className: closClassNames,
        onMouseOver: this.toggleCloseButton.bind(this, true),
        onMouseOut: this.toggleCloseButton.bind(this, false)
      }, void 0, _jsx('img', {
        src: require('./team_x_icon@2x.png'),
        onClick: this.removeMember,
        title: 'Remove',
        alt: 'Remove',
        className: 'delete_team_invite_link'
      }));
    } else {

      sections.actionsColumn = _jsx('td', {
        className: 'action_col',
        style: { opacity: 1 }
      }, void 0, this.shouldShowActionMenu() ? _jsx('div', {
        className: 'arrow',
        onMouseOver: this.toggleMenu.bind(this, true),
        onMouseOut: this.toggleMenu.bind(this, false)
      }, void 0, _jsx('ul', {}, void 0, _hfReactHelper2['default'].isHelloSign() ? _jsx('li', {
        className: 'menuLink template_access'
      }, 'menu', _jsx('a', {
        href: '#',
        className: 'show_template_access_link',
        onClick: this.showTemplates
      }, void 0, _ref4, 'Templates')) : void 0, sections.adminMenuItem, sections.devMenuItem, sections.memberMenuItem, this.userIsAdmin() ? _jsx('li', {
        className: 'menuLink'
      }, void 0, _jsx('a', {
        href: '#',
        className: 'remove_team_member',
        onClick: this.removeMember
      }, void 0, _ref5, 'Remove')) : void 0)) : void 0);
    }

    // TODO - don't do this - need to use CSS ellipsis instead
    var emailAddress = member.emailAddress.toLowerCase();
    if (emailAddress.length > 30) {
      emailAddress = emailAddress.substring(0, 27) + '...';
    }

    return _jsx('tr', {
      className: classNames,
      style: { display: "table-row" }
    }, void 0, _jsx('td', {
      className: 'email_col'
    }, void 0, member.emailAddress), _jsx('td', {
      className: 'role_col'
    }, void 0, member.pending ? "(Invited)" : member.getRoleTypeLabel()), _hfReactHelper2['default'].isHelloSign() ? _jsx('td', {
      className: 'templates_col'
    }, void 0, member.numTemplates) : void 0, sections.actionsColumn);
  }
});

module.exports = TeamMember;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/app/content/team/member.jsx
 ** module id = 718
 ** module chunks = 0
 **/